import React, { useCallback, useEffect, useState } from "react";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { BtnAlternative } from "../../../../../components/shares/button/Button";
import Result from "../../../../../assets/img/icons/Docs.svg";
import Play from "../../../../../assets/img/icons/Iconly-Light-Play.svg";
import Edit from "../../../../../assets/img/icons/Iconly-Light-Edit.svg";
import { Card } from "./../../../../shares/card/Card";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link, useLocation, useMatch, useParams } from "react-router-dom";
import { useSession } from "../../../../../contexts/SessionContext";
import useFetch from "../../../../../hooks/useFetch";
import { toast } from "react-toastify";

function LeftSidebar({ session }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { contentId, setContentId, sessionList, setSessionList } = useSession();

  const [sessionId, setSessionId] = useState();
  const { videoSelect, setVideoSelect, sideBar, setsideBar, sessionNum, contentInfo, setContentInfo, setSessionPervPrecense ,isReady,setIsReady} =
    useSession();
  const { Id } = useParams();
  const classes = useMatch("dashboard/classes/:Id/:Id");

  const fetchData = useFetch({
    method: "GET",
    url: `classroom/${Id}/`,
    noHeader: false,
    trigger: classes ? true : false,
    // errMessage: () => toast.error("مشکلی در دریافت اطلاعات قسمت ها پیش آمده", { position: "bottom-left", rtl: true, autoClose: 2000 }),
    setter: setSessionId,
  });

  useEffect(() => {
    setSessionList([
      sessionId?.Class?.content1_url1 === "" ? null : Number.parseInt(sessionId?.Presence?.classroom_presence[0]),
      sessionId?.Class?.content2_url1 === "" ? null : Number.parseInt(sessionId?.Presence?.classroom_presence[1]),
      sessionId?.Class?.content3_url1 === "" ? null : Number.parseInt(sessionId?.Presence?.classroom_presence[2]),
      sessionId?.Class?.content4_url1 === "" ? null : Number.parseInt(sessionId?.Presence?.classroom_presence[3]),
      sessionId?.Class?.content5_url1 === "" ? null : Number.parseInt(sessionId?.Presence?.classroom_presence[4]),
    ]);
  }, [sessionId]);
  useCallback(() => {
    if (sessionList && isReady) {
    setTimeout(window.location.reload(),500)
      
    }
  }, [sessionList,isReady])
  
  // Sections come from Class.content1_url1 .. content5_url1. The previous
  // markup repeated the same block five times; deriving the list keeps the
  // behaviour identical and makes an active state possible.
  const sections = [1, 2, 3, 4, 5]
    .map((number) => ({
      number,
      url: sessionId?.Class?.[`content${number}_url1`],
    }))
    .filter((section) => section.url);

  const selectSection = (section) => {
    setContentId(section.number);
    setContentInfo(section.url);
    setSessionPervPrecense(sessionId?.Presence?.classroom_presence_percentage);
    setIsReady(false);
  };

  return (
    <aside
      className={`sidebarLeft shrink-0 pt-3xl ${
        sideBar ? "max-md:w-52" : "max-md:hidden"
      }`}
    >
      <div className="sidebarLeft-wrapper">
        <div className="sidebarLeft-container flex flex-col max-md:p-0 px-4xl gap-md">
          <h2 className="flex items-center gap-xs pb-xl text-md text-ink-muted max-md:text-sm">
            <NotificationsOutlinedIcon fontSize="medium" />
            رویدادها
          </h2>

          {sideBar ? (
            <ul className="flex flex-col gap-sm">
              {sections.map((section) => {
                const isActive = contentId === section.number;
                return (
                  <li key={section.number}>
                    <button
                      type="button"
                      onClick={() => selectSection(section)}
                      aria-current={isActive ? "true" : undefined}
                      className={`w-full rounded-card border text-center transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary ${
                        isActive
                          ? "border-primary bg-primary-soft text-primary"
                          : "border-rule-subtle bg-surface text-ink-muted hover:border-rule hover:bg-surface-sunken"
                      }`}
                    >
                      <span className="block px-lg pt-md text-sm">بخش</span>
                      <span className="block px-lg pb-md text-3xl font-semibold max-md:text-xl">
                        {section.number}
                      </span>
                    </button>
                  </li>
                );
              })}
            </ul>
          ) : (
            <ul className="flex flex-col gap-md">
              {cardArray.map((item) => (
                <li key={item.id}>
                  <Card className="px-md pt-xl pb-md">
                    <h3 className="text-md pb-sm text-ink">{item.name}</h3>
                    <p className="text-sm pb-lg text-ink-subtle">{item.name}</p>
                    <BtnAlternative
                      className="border-rule-subtle text-primary border-2 py-4 px-4xl"
                      url={item.path}
                      icon={item.icon}
                      text={item.btnTxt}
                    />
                  </Card>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </aside>
  );
}

export default LeftSidebar;

const cardArray = [
  {
    id: 1,
    name: "نتیجه امتحان",
    icon: Result,
    btnTxt: "نتیجه",
    path: "/dashboard/exams",
  },
  {
    id: 2,
    name: "جلسه جدید",
    icon: Play,
    btnTxt: "تماشا",
    path: "/dashboard/classes",
  },
  {
    id: 3,
    name: "تکلیف جدید",
    icon: Edit,
    btnTxt: "انجام",
    path: "/dashboard/homework",
  },
];
